import React, { useState, useContext } from 'react';
import { CartContext } from '../context/CartContext';

export default function PerfumeCard({ item, category, hoveredId, setHoveredId }) {
  const { addToCart } = useContext(CartContext);

  // ✅ default qty = 50 kg
  const [qty, setQty] = useState(50);

  const isHovered = hoveredId === item.id;
  const hasImage = Boolean(item.image || item.img);

  // ✅ clamp function to enforce min & max
  const clampQty = (value) => {
    if (!value) return 5;
    return Math.min(500, Math.max(5, value));
  };

  return (
    <div
      onMouseEnter={() => setHoveredId(item.id)}
      onMouseLeave={() => setHoveredId(null)}
      className={`card ${isHovered ? 'is-hovered' : ''}`}
      role="article"
      aria-labelledby={`perfume-${item.id}`}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      {/* IMAGE */}
      {hasImage && (
        <div className="card-image">
          <img
            src={item.image || item.img}
            alt={item.name}
            loading="lazy"
          />
        </div>
      )}

      {/* TEXT CONTENT */}
      <div style={{ flex: '1 1 auto' }}>
        <h3 id={`perfume-${item.id}`} className="card-title">
          {item.name}
        </h3>

        {item.description && (
          <p className="card-desc" style={{ marginTop: 8 }}>
            {item.description}
          </p>
        )}
      </div>

      {/* ACTIONS */}
      <div style={{ marginTop: 'auto' }}>
        <div className="card-controls" style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 8 }}>

          {/* ✅ Quantity input */}
          <input
            type="number"
            min="5"
            max="500"
            value={qty}
            onChange={(e) => setQty(clampQty(Number(e.target.value)))}
            className="qty"
            aria-label={`Quantity for ${item.name}`}
            style={{ width: 80 }}
          />

          {/* ✅ kg label */}
          <span style={{ fontWeight: 500 }}>kg</span>

          <button
            onClick={() =>
              addToCart({ ...item, quantity: qty, category })
            }
            className="btn"
            aria-label={`Add ${item.name} to cart`}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}
